import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dayTranslate'
})
export class DayTranslatePipe implements PipeTransform {
  private joursMap: { [key: string]: string } = {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche'
  };

  transform(day: string): string {
    return this.joursMap[day] || day;
  }
}
